<template>
  <div class="card-header d-flex justify-content-between align-items-center">
    <h4 class="card-header-title mb-0 font-weight-bold">IDP Attendance</h4>
  </div>
</template>

<script>
export default {
  name: "Header",
};
</script>
